import { z } from "zod";

export const TierSchema = z.enum(["S", "A", "B", "C", "D"]);
export type Tier = z.infer<typeof TierSchema>;

export const RoleSchema = z.enum(["commander", "defender", "attacker", "saboteur", "support"]);
export type Role = z.infer<typeof RoleSchema>;

export const ChassisSchema = z.enum(["tank", "mecha", "tripod", "android", "drone_carrier"]);
export type Chassis = z.infer<typeof ChassisSchema>;

export const ManufacturerSchema = z.enum(["HEX", "KRG", "VLK", "OMC", "RDL"]);
export type Manufacturer = z.infer<typeof ManufacturerSchema>;

export const ResourceSchema = z.enum(["RAT", "POL", "ALY", "ENC", "SCR"]);
export type Resource = z.infer<typeof ResourceSchema>;

export const StoredResourceSchema = z.enum(["RAT", "POL", "ALY", "ENC"]);
export type StoredResource = z.infer<typeof StoredResourceSchema>;

export const LocalizedTextSchema = z.object({ de: z.string().min(1), en: z.string().min(1) });
export type LocalizedText = z.infer<typeof LocalizedTextSchema>;

export const TIERS: readonly Tier[] = ["S", "A", "B", "C", "D"];
export const ROLES: readonly Role[] = ["commander", "defender", "attacker", "saboteur", "support"];
export const RESOURCES: readonly Resource[] = ["RAT", "POL", "ALY", "ENC", "SCR"];
export const STORED_RESOURCES: readonly StoredResource[] = ["RAT", "POL", "ALY", "ENC"];

export const TIER_COLORS: Record<Tier, string> = {
  S: "#F5C542",
  A: "#A855F7",
  B: "#3B82F6",
  C: "#22C55E",
  D: "#9CA3AF",
};

export const TIER_ABILITY_COUNT: Record<Tier, number> = { S: 5, A: 4, B: 3, C: 2, D: 1 };

export const TIER_STAT_MULT: Record<Tier, number> = { S: 2.0, A: 1.6, B: 1.35, C: 1.15, D: 1.0 };

/** Combat chassis triangle: key beats value (+10 % damage). Support chassis are outside the triangle. */
export const CHASSIS_BEATS: Partial<Record<Chassis, Chassis>> = { tank: "mecha", mecha: "tripod", tripod: "tank" };

export const SUPPORT_CHASSIS: readonly Chassis[] = ["android", "drone_carrier"];

export function idPattern(prefix: string) {
  return z.string().regex(new RegExp(`^${prefix}\\.[a-z0-9_]+$`), `id must look like ${prefix}.snake_case`);
}

export const MAX_LEVEL = 30;
